// Exporta todas as questões das bancas com LAZY LOADING
// As questões são carregadas sob demanda, não no startup do app

// ==================== CACHE EM MEMÓRIA ====================
// Cache para evitar recarregar questões já carregadas
const questionsCache = {
    cespe: null,
    fcc: null,
    cesgranrio: null,
    vendas: null,
    fgv: null,
    vunesp: null,
    outras: null,
    bbEscriturario2018: null,
    bbEscriturario2015: null,
    bbEscriturario2013Fcc: null,
    bbEscriturario2011Fcc: null,
    bbEscriturario2010: null,
    bbEscriturario2009Cespe: null,
    bbAgenteComercial2022: null,
    bbAgenteComercial2021: null,
    enade2025Direito: null,
};

// ==================== FUNÇÕES DE CARREGAMENTO LAZY ====================

// Carrega questões da CESPE sob demanda
const loadCespeQuestions = async () => {
    if (questionsCache.cespe) return questionsCache.cespe;
    const data = (await import('./cespe.json')).default;
    questionsCache.cespe = data;
    return data;
};

// Carrega questões da FCC sob demanda
const loadFccQuestions = async () => {
    if (questionsCache.fcc) return questionsCache.fcc;
    const data = (await import('./fcc.json')).default;
    questionsCache.fcc = data;
    return data;
};

// Carrega questões da CESGRANRIO sob demanda
const loadCesgranrioQuestions = async () => {
    if (questionsCache.cesgranrio) return questionsCache.cesgranrio;
    const data = (await import('./cesgranrio.json')).default;
    questionsCache.cesgranrio = data;
    return data;
};

// Carrega questões de Vendas/Negociações sob demanda
const loadVendasQuestions = async () => {
    if (questionsCache.vendas) return questionsCache.vendas;
    const data = (await import('./vendas_negocios.json')).default;
    questionsCache.vendas = data;
    return data;
};

// Carrega questões da prova BB Escriturário 2018 (CESGRANRIO) sob demanda
const loadBBEscriturario2018 = async () => {
    if (questionsCache.bbEscriturario2018) return questionsCache.bbEscriturario2018;
    const data = (await import('./bb_escriturario_2018.js')).default;
    questionsCache.bbEscriturario2018 = data;
    return data;
};

// Carrega questões da prova BB Escriturário 2015 (CESGRANRIO) sob demanda
const loadBBEscriturario2015 = async () => {
    if (questionsCache.bbEscriturario2015) return questionsCache.bbEscriturario2015;
    const data = (await import('./bb_escriturario_2015.js')).default;
    questionsCache.bbEscriturario2015 = data;
    return data;
};

// Carrega questões da prova BB Escriturário 2013 (FCC) sob demanda
const loadBBEscriturario2013Fcc = async () => {
    if (questionsCache.bbEscriturario2013Fcc) return questionsCache.bbEscriturario2013Fcc;
    const data = (await import('./bb_escriturario_2013_fcc.js')).default;
    questionsCache.bbEscriturario2013Fcc = data;
    return data;
};

// Carrega questões da prova BB Escriturário 2011 (FCC) sob demanda
const loadBBEscriturario2011Fcc = async () => {
    if (questionsCache.bbEscriturario2011Fcc) return questionsCache.bbEscriturario2011Fcc;
    const data = (await import('./bb_escriturario_2011_fcc.js')).default;
    questionsCache.bbEscriturario2011Fcc = data;
    return data;
};

// Carrega questões da prova BB Escriturário 2010 (CESGRANRIO) sob demanda
const loadBBEscriturario2010 = async () => {
    if (questionsCache.bbEscriturario2010) return questionsCache.bbEscriturario2010;
    const data = (await import('./bb_escriturario_2010.js')).default;
    questionsCache.bbEscriturario2010 = data;
    return data;
};

// Carrega questões da prova BB Escriturário 2009 (CESPE) sob demanda
const loadBBEscriturario2009Cespe = async () => {
    if (questionsCache.bbEscriturario2009Cespe) return questionsCache.bbEscriturario2009Cespe;
    const data = (await import('./bb_escriturario_2009_cespe.js')).default;
    questionsCache.bbEscriturario2009Cespe = data;
    return data;
};

// Carrega questões da prova BB Agente Comercial 2022 (CESGRANRIO) sob demanda
const loadBBAgenteComercial2022 = async () => {
    if (questionsCache.bbAgenteComercial2022) return questionsCache.bbAgenteComercial2022;
    const data = (await import('./bb_agente_comercial_2022.js')).default;
    questionsCache.bbAgenteComercial2022 = data;
    return data;
};

// Carrega questões da prova BB Agente Comercial 2021 (CESGRANRIO) sob demanda
const loadBBAgenteComercial2021 = async () => {
    if (questionsCache.bbAgenteComercial2021) return questionsCache.bbAgenteComercial2021;
    const data = (await import('./bb_agente_comercial_2021.js')).default;
    questionsCache.bbAgenteComercial2021 = data;
    return data;
};

// Carrega as questões do ENADE 2025 — Direito (INEP) sob demanda
const loadEnade2025Direito = async () => {
    if (questionsCache.enade2025Direito) return questionsCache.enade2025Direito;
    const data = (await import('./inep_enade_2025_direito.js')).default;
    questionsCache.enade2025Direito = data;
    return data;
};

// ==================== DADOS DAS BANCAS (estático, leve) ====================
export const BANCAS = [
    {
        id: 'inep',
        name: 'INEP',
        shortName: 'INEP',
        icon: '🎓',
        color: '#0B3D75',
        description: 'Instituto Nacional de Estudos e Pesquisas Educacionais Anísio Teixeira',
        concursos: ['ENADE', 'ENAMED', 'Revalida', 'ENARE'],
        caracteristicas: ['Quatro alternativas (A–D)', 'Formação Geral + Componente Específico', 'Muito texto-base'],
    },
    {
        id: 'cespe',
        name: 'CESPE/CEBRASPE',
        shortName: 'CESPE',
        icon: '🎯',
        color: '#3B82F6',
        description: 'Centro Brasileiro de Pesquisa em Avaliação',
        concursos: ['PF', 'PRF', 'Banco do Brasil', 'TCU', 'STJ', 'MPU'],
        caracteristicas: ['Questões de Certo/Errado', 'Prova discursiva', 'Cespe penaliza erros'],
    },
    {
        id: 'fcc',
        name: 'FCC',
        shortName: 'FCC',
        icon: '📝',
        color: '#10B981',
        description: 'Fundação Carlos Chagas',
        concursos: ['TRT', 'TRF', 'TRE', 'SEFAZ', 'Tribunais'],
        caracteristicas: ['Múltipla escolha', 'Foco em legislação', 'Provas extensas'],
    },
    {
        id: 'cesgranrio',
        name: 'CESGRANRIO',
        shortName: 'CESGRANRIO',
        icon: '🏦',
        color: '#FF6B35',
        description: 'Fundação CESGRANRIO',
        concursos: ['Petrobras', 'Banco do Brasil', 'Caixa', 'BNDES', 'IBGE'],
        caracteristicas: ['Múltipla escolha', 'Foco em bancários', 'Questões longas'],
    },
    {
        id: 'fgv',
        name: 'FGV',
        shortName: 'FGV',
        icon: '🏛️',
        color: '#8B5CF6',
        description: 'Fundação Getúlio Vargas',
        concursos: ['OAB', 'Senado', 'CGU', 'Prefeituras'],
        caracteristicas: ['Alta complexidade', 'Textos longos', 'Interpretação profunda'],
        emBreve: true,
    },
    {
        id: 'vunesp',
        name: 'VUNESP',
        shortName: 'VUNESP',
        icon: '📚',
        color: '#F59E0B',
        description: 'Fundação VUNESP',
        concursos: ['Polícia Civil SP', 'TJ-SP', 'Prefeituras SP'],
        caracteristicas: ['Foco em São Paulo', 'Múltipla escolha', 'Legislação estadual'],
        emBreve: true,
    },
];

// ==================== FUNÇÃO PRINCIPAL - LAZY LOADING ====================

/**
 * Obtém questões de uma banca específica (LAZY LOADING)
 * As questões são carregadas sob demanda e cacheadas em memória
 * 
 * @param {string} bancaId - ID da banca (cespe, fcc, cesgranrio, fgv, vunesp)
 * @returns {Promise<Array>} - Array de questões
 */
export const getQuestionsByBanca = async (bancaId) => {
    switch (bancaId) {
        case 'inep':
            return loadEnade2025Direito();

        case 'cespe': {
            const cespeData = await loadCespeQuestions();
            const bb2009cespe = await loadBBEscriturario2009Cespe();
            return [...cespeData, ...bb2009cespe];
        }

        case 'fcc': {
            const fccData = await loadFccQuestions();
            const vendasData = await loadVendasQuestions();
            const bb2013fcc = await loadBBEscriturario2013Fcc();
            const bb2011fcc = await loadBBEscriturario2011Fcc();
            const vendasFCC = vendasData.filter(q => q.banca === 'FCC');
            return [...fccData, ...vendasFCC, ...bb2013fcc, ...bb2011fcc];
        }

        case 'cesgranrio': {
            const cesgranrioData = await loadCesgranrioQuestions();
            const vendasData = await loadVendasQuestions();
            const bb2018 = await loadBBEscriturario2018();
            const bb2015 = await loadBBEscriturario2015();
            const bb2010 = await loadBBEscriturario2010();
            const bbAc2022 = await loadBBAgenteComercial2022();
            const bbAc2021 = await loadBBAgenteComercial2021();
            const vendasCesgranrio = vendasData.filter(q => q.banca === 'CESGRANRIO');
            return [...cesgranrioData, ...vendasCesgranrio, ...bb2018, ...bb2015, ...bb2010, ...bbAc2022, ...bbAc2021];
        }

        case 'fgv': {
            const vendasData = await loadVendasQuestions();
            return vendasData.filter(q => q.banca === 'FGV');
        }

        case 'vunesp':
            return [];

        case 'outras': {
            const vendasData = await loadVendasQuestions();
            return vendasData.filter(q => !['FCC', 'CESGRANRIO', 'FGV'].includes(q.banca));
        }

        case 'all': {
            // Carrega todas as questões (para filtros gerais)
            const [cespe, fcc, cesgranrio, vendas, bb2018, bb2015, bb2013fcc, bb2011fcc, bb2010, bb2009cespe, bbAc2022, bbAc2021] = await Promise.all([
                loadCespeQuestions(),
                loadFccQuestions(),
                loadCesgranrioQuestions(),
                loadVendasQuestions(),
                loadBBEscriturario2018(),
                loadBBEscriturario2015(),
                loadBBEscriturario2013Fcc(),
                loadBBEscriturario2011Fcc(),
                loadBBEscriturario2010(),
                loadBBEscriturario2009Cespe(),
                loadBBAgenteComercial2022(),
                loadBBAgenteComercial2021(),
            ]);
            return [...cespe, ...fcc, ...cesgranrio, ...vendas, ...bb2018, ...bb2015, ...bb2013fcc, ...bb2011fcc, ...bb2010, ...bb2009cespe, ...bbAc2022, ...bbAc2021];
        }

        default:
            return [];
    }
};

// ==================== FUNÇÕES DE FILTRO (ASYNC) ====================

/**
 * Obtém questões filtradas de uma banca
 */
export const getFilteredQuestions = async (bancaId, filters = {}) => {
    const questions = await getQuestionsByBanca(bancaId);

    return questions.filter(q => {
        if (filters.ano && q.ano !== filters.ano) return false;
        if (filters.disciplina && q.disciplina !== filters.disciplina) return false;
        if (filters.orgao && q.orgao !== filters.orgao) return false;
        if (filters.assunto && q.assunto !== filters.assunto) return false;
        return true;
    });
};

/**
 * Obtém disciplinas únicas de uma banca
 */
export const getDisciplinasByBanca = async (bancaId) => {
    const questions = await getQuestionsByBanca(bancaId);
    const disciplinas = [...new Set(questions.map(q => q.disciplina))];
    return disciplinas.sort();
};

/**
 * Obtém anos únicos de uma banca
 */
export const getAnosByBanca = async (bancaId) => {
    const questions = await getQuestionsByBanca(bancaId);
    const anos = [...new Set(questions.map(q => q.ano))];
    return anos.sort((a, b) => b - a);
};

/**
 * Obtém órgãos únicos de uma banca
 */
export const getOrgaosByBanca = async (bancaId) => {
    const questions = await getQuestionsByBanca(bancaId);
    const orgaos = [...new Set(questions.map(q => q.orgao))];
    return orgaos.sort();
};

/**
 * Obtém total de questões de uma banca (para exibição)
 */
export const getTotalQuestionsByBanca = async (bancaId) => {
    const questions = await getQuestionsByBanca(bancaId);
    return questions.length;
};

/**
 * Limpa o cache (útil para testes ou se adicionar questões dinamicamente)
 */
export const clearQuestionsCache = () => {
    Object.keys(questionsCache).forEach(key => {
        questionsCache[key] = null;
    });
};

export default { BANCAS, getQuestionsByBanca, getFilteredQuestions };
